"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_CONSENT_GROUPS = void 0;
//All possible categories are stored in https://app.onetrust.com/cookies/categorizations?tab=Categories
// The following categories are used in the code:
// - C0001: Strictly necessary
// - C0002: Performance
// - C0003: Functional
// - C0004: Targeting
// - C0005: Social Media
// If the categories change, the code must be updated to reflect the changes.
exports.DEFAULT_CONSENT_GROUPS = {
    C0001: true, // Strictly necessary
    C0002: false, // Performance
    C0003: false, // Functional
    C0004: false, // Targeting
    C0005: false, // Social Media
};
//# sourceMappingURL=constants.js.map